<template>
  <div>
      参数分类
  </div>
</template>
<script>
/**
 * 破包列表, 破包添加, 待补货订单,
 * 详情
 */
import {
  replenishlist, replenishadd, damagedgetBrokeOrder,
  replenishdetail,
  stockquerystock, stocklocationfindAll, addressfindByCompanyId,
  shipfindAll, findAll, qiniuupload,
  stockadd, crmcurrency
} from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      list: [],
      formLabelWidth: '120px',
      centerDialogVisible: false,
      purchaseContract: [],
      form: {
        companyId: '', //  库位ID
        // shipBusinessId: '', //  船务ID
        purchaseContract: '', //  采购合同
      },
      crmcurrencyList: [],
      title: '', //  添加窗口标题
      stocklist: [], //  库位列表
      stockadresslist: [], //  仓储地址列表
      shiplist: [], //  船务列表
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      uploadUrl: '', //  上传地址前缀
      roleCode: '',
      para: { //  查询条件
        searchKey: '', //  订单编号
        flag: 1, //  订单状态
        pageIndex: 1, //  页码
        pageSize: 10 //  每页数量
      },
      typelist: [
        {
          id: 1,
          name: '采购破包',
        },
        {
          id: 2,
          name: '销售破包',
        }
      ],
      orderlist: [],
      currentStatus: '',
      batchNumslist: [],
      detailpindex: 1,
      detailpsize: 10,
      detaillist: [], //  详情数据
      detailtotal: 0, //  详情总数
      formwidth: '35%',
      row: '',
    }
  },
  mounted () {
    this.getreplenishlist()
    this.getToken()
    let roleCode = sessionStorage.getItem('roleCode')
    console.log(roleCode)
    this.roleCode = roleCode
  },
  methods: {
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    handleSearch (type, val) {
      this.getreplenishlist()
    },
    handlechangestock (val) {
      console.log(val)
      this.getaddressfindByCompanyId(val)
    },
    getaddressfindByCompanyId (companyId) {
      let para = {
        companyId: companyId,
        typeId: 3
      }
      addressfindByCompanyId(para).then(data => {
        console.log(data)
        this.stockadresslist = data.data.data
        // this.stockadresslist.push()
      })
    },
    getcrmcurrency () { //  货币列表
      let para = {}
      crmcurrency(para).then(data => {
        console.log(data)
        this.crmcurrencyList = data.data.data
      })
    },
    getdamagedgetBrokeOrder () { //  待补货订单
      let para = {}
      damagedgetBrokeOrder(para).then(data => {
        console.log(data)
        this.orderlist = data.data.data
      })
    },
    setValue (val) {
      console.log(val)
      this.form.breakNum = val.breakNum
      this.batchNumslist = val.batchNumVos
      this.form.damageId = val.id
    },
    handleBeforeUpload (file) { //  上传之前
      this.qiniu.key = `purchaseContract${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList) { //  上传成功之后
      this.form.purchaseContract = this.uploadUrl + '/' + response.key
      this.purchaseContract.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove (file, fileList) {
      this.purchaseContract = []
    },
    handlequery (row) { //  查看详情
      this.currentStatus = 'query'
      this.centerDialogVisible = true
      this.title = '详情'
      this.formwidth = '70%'
      console.log(row)
      this.row  = row
      
      this.getreplenishdetail(row)
      // this.$router.push({ path: '/totaldetail', query: { name: row }}) 
    },
    changeindex (type, val) {
     this.detailpindex = val
     this.getreplenishdetail(this.row)
    },
    getreplenishdetail (row) { //  查看详情
      let para = {
        pageIndex: this.detailpindex,
        pageSize: 10,
        flag: this.para.flag,
        goodsId: row.goodsId
      }
      replenishdetail(para).then(data => {
        this.detaillist = data.data.data.rows
        this.detailtotal = data.data.data.total
      })
    },
    handleAdd () { //  新增
      this.currentStatus = 'add'
      this.formwidth = '35%'
      this.centerDialogVisible = true
      this.title = '销售破包新增'
      this.form = {}
      this.form = {
        batchNums: [
          {
            batchId: '',
            lotNum: '',
            enterStockNum: ''
          }
        ]
      }
      this.getstocklocationfindAll()
      this.getdamagedgetBrokeOrder() //  待补货
    },
    handlesuccess () { //  提交表单信息
      console.log(this.form)
      if (this.currentStatus === 'query') {
        this.centerDialogVisible = false
      } else {
        this.form.orderId = this.form.orderId.orderId
        let para = new URLSearchParams()
        para.append('brokeAddRequest', JSON.stringify(this.form))
        replenishadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getreplenishlist()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    handleRemovePara (item) { //  删除参数
      let dom = this.form.batchNums
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    handleAddPara () { //  新增参数
      this.form.batchNums.push(
        {
          batchId: '', //  批号id
          enterStockNum: '', //  批号销售数量
        },
      )
    },
    getreplenishlist (s) { //  查询补货统计列表
      // let para = new URLSearchParams(this.para)
      replenishlist(this.para).then(data => {
        console.log(data)
        this.list = data.data.data.rows
      })
    },
    getstocklocationfindAll () { //  库位列表
      // let para = {
      //   status: 1
      // }
      // stocklocationfindAll(para).then(data => {
      //   console.log(data.data.data)
      //   this.stocklist = data.data.data
      // })
      let para = {
        'status': 1,
        'typeId': 8
      }
      findAll(para).then(data => {
        console.log(data)
        this.stocklist = data.data.data
        this.stocklist.push({id: 0, chineseName: '直接发货'})
      })
    },
    getshipfindAll () { //  船务列表
      let para = {
        travelPosition: 2,
        status: 1
      }
      shipfindAll(para).then(data => {
        console.log(data)
        this.shiplist = data.data.data.rows
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
.cghthstyle
  label
    line-height 20px
.disflexbtw {
  display flex
  justify-content space-between
  .el-form-item {
    display flex
  }
}
</style>
